'use strict';
import FluxConstant from 'flux-constant';


export default FluxConstant.set([
    'RESET',
    'GET_RESULTS',
    'GET_RESULTS_RESPONSE'
]);
